import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";
import { TancadasTurnoApi } from "../api/TancadasTurnoApi";

// Todas las tancadas del turno, sin importar la orden de producción de cada
// una. Es de solo lectura: el turno llega en la ruta y no cambia dentro de la
// pantalla
export const useTancadasTurno = (turnoId) => {
    const { getTancadasTurno, descargarTancadasTurnoExcel, cargando } =
        TancadasTurnoApi();

    const [turno, setTurno] = useState(null);
    const [drcPadresPT, setDrcPadresPT] = useState([]);
    const [resumen, setResumen] = useState(null);
    const [comparativo, setComparativo] = useState(null);
    const [tancadas, setTancadas] = useState([]);
    const [mensajeError, setMensajeError] = useState("");

    const GetTancadasTurno = async () => {
        try {
            setMensajeError("");

            const response = await getTancadasTurno({ turno_id: turnoId });

            setTurno(response.turno);
            setDrcPadresPT(response.drc_padres_pt || []);
            setResumen(response.resumen || null);
            setComparativo(response.comparativo || null);
            setTancadas(response.tancadas || []);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las tancadas del turno",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setTurno(null);
            setDrcPadresPT([]);
            setResumen(null);
            setComparativo(null);
            setTancadas([]);
            setMensajeError(errorMsg);
        }
    };

    useEffect(() => {
        if (turnoId) GetTancadasTurno();
    }, [turnoId]);

    const DescargarExcel = async () => {
        try {
            await descargarTancadasTurnoExcel({ turno_id: turnoId });
        } catch (error) {
            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al exportar las tancadas del turno",
                ),
                "Error",
                3000,
            );
        }
    };

    return {
        turno,
        drcPadresPT,
        resumen,
        comparativo,
        tancadas,
        mensajeError,
        cargando,

        DescargarExcel,
    };
};
